module.exports = __webpack_public_path__ + "img/1-1.322a065e.png";